// 一轮(「一程」)固定做几关。答对一关、或探底关不论对错,都算过了一关;答错重试不算新的一关。
// 后端统计脚本 scripts/analytics_report.py 的 ROUND_SIZE 要保持一致。
export const ROUND_SIZE_BY_AGE_BAND = { '6-8': 10, '9-12': 10 };

export function roundSizeFor(ageBand) {
  return ROUND_SIZE_BY_AGE_BAND[ageBand] ?? 10;
}

export function newRoundId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `r-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

// 一程的奖牌:按首答正确率(一次就过的关数 / 过关数)。没到铜牌也给「勤学章」—— 无挫败,每一程都有收获
export const MEDALS = [
  { key: 'gold', icon: '🥇', min: 0.9 },
  { key: 'silver', icon: '🥈', min: 0.7 },
  { key: 'bronze', icon: '🥉', min: 0.5 },
  { key: 'effort', icon: '🏵️', min: 0 },
];

export function medalFor(firstTry, done) {
  const rate = done ? firstTry / done : 0;
  return MEDALS.find((m) => rate >= m.min);
}
